import request from '@/utils/request'

export const getLedgerReconciliation = params => request.get('/accounting/reports/ledger-reconciliation', { params })
